export const baseUrl = () => {
  let baseUrl = process.env.REACT_APP_LIVE_BASE_URL_LMS_ADMIN
  return baseUrl;
}